import {HTTP} from '../../../../services/api-service.js';
import commonObj from '../../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = '';

const mixMatchStore = {
    namespaced: true,
    state:{
        totalItem:0,
        q : {
            tableNeedQuery: tableName,
            isOuterJoin: false,       
            searchCriteria: "",
            orderBy: "",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions:{
      getAllMMRule({ commit, state }, param) {
        return new Promise((resolve, reject) => {
          state.q.tableNeedQuery = "MMRule";
          HTTP.post(baseUrl + "/qgl/listvalue", state.q)
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },  
      saveMixMatch({ commit }, param) {
        return new Promise((resolve, reject) => {
          HTTP.post(
            baseUrl + "/entity/SaveMixMatch",
            JSON.stringify({
                mmrule: param.mmrule,
                mmcond: param.mmcond,
                mmconditem: param.mmconditem,
            })
          )
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      getCond({ commit, state }, param) {
        return new Promise((resolve, reject) => {
          HTTP.post(baseUrl + "/entity/GetCond", { mmruleid: param.mmruleid })
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
      getCondItem({ commit, state }, param) {
        return new Promise((resolve, reject) => {
          HTTP.post(baseUrl + "/entity/GetCondItem", { mmruleid: param.mmruleid })
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },

      deleteMixMatch({ commit, state }, param) {
        return new Promise((resolve, reject) => {
          HTTP.post(baseUrl + "/entity/DeleteMixMatch", { mmruleid: param.mmruleid })
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
    }
};
export default mixMatchStore;